import type { GlobalSearchOptions, SearchResultItem } from '../../../shared/domain/globalSearch/types.no-deps'
import type { Endpoint, Route, Request, RequestArgs } from '../types.no-deps'

export const route: Route = { method: 'POST', pattern: '/api/search' }

type Params = never
type Body = {
    q: string

    // If an `itemsFilter` object is passed, the search will only be performed on the provided entity IDs.
    itemsFilters?: GlobalSearchOptions['itemsFilters']

    sortBy?: GlobalSearchOptions['sortBy']
}

type Query = never
type Output = { results: SearchResultItem[] }

export type SearchEndpoint = Endpoint<Params, Body, Query, Output>

export const searchRequest = (request: Request, args: RequestArgs<SearchEndpoint>) =>
    request<SearchEndpoint>(route, args)
